<mat-progress-spinner
  class="spinner"
  mode="indeterminate"
  *ngIf="showSpinner">
</mat-progress-spinner>

<ng-template #confirmDeleteLink>
  <mat-dialog-content class="modal-body">
    Потвердите удаление ссылки
    <button mat-raised-button class="modal-body__button" (click)="deleteCurrentLink(); closeDialog()">Подтверждаю</button>
  </mat-dialog-content>
</ng-template>

<ng-template #confirmDeleteAward>
  <mat-dialog-content class="modal-body">
    Потвердите удаление награды
    <button mat-raised-button class="modal-body__button" (click)="deleteAward()">Подтверждаю</button>
  </mat-dialog-content>
</ng-template>

<ng-container *ngIf="awards">
  <div class="award" [class.for-teacher]="forTeacher">
    <div class="award__nav">
      <a *ngIf="!forTeacher" class="award__nav__back" (click)="back()">
        <span><mat-icon>arrow_back</mat-icon></span>
        <span>Другие награды</span>
      </a>
      <mat-paginator *ngIf="awards?.length > 1"
                     [length]="awards?.length"
                     [pageSize]="1"
                     (page)="getPaginatorData($event)"
                     [hidePageSize]="true"
                     showFirstLastButtons>
      </mat-paginator>
    </div>
    <div class="award__body" [class.not-active]="award.is_used_card && cardAward.character?.icon_url">
      <div class="award__body__preview">
        <div class="award__body__preview__active">
          <img src="{{ activatedImage }}" alt="{{ cardAward.title }}">
        </div>
        <div *ngIf="cardAward.images.length > 1" class="award__body__preview__images">
          <span *ngFor="let image of cardAward.images"
                class="award__body__preview__images__item"
                [class.active]="image.url == activatedImage"
                (click)="activatedImage = image.url">
            <img src="{{ image.url }}" alt="{{ cardAward.title }}">
          </span>
        </div>
      </div>
      <form *ngIf="award" class="award__body__info" [formGroup]="form" (ngSubmit)="updateData()">
        <div class="scans" *ngIf="award.scans.length > 0">
          <p>Турнирные листы ученика:</p>
          <ul>
            <li *ngFor="let scan of award.scans; let i = index;">
              <a href="{{ scan.url }}">{{ scan.title }}</a>
            </li>
          </ul>
        </div>
        <span class="award__body__info__title">
          {{ cardAward.title }}
        </span>
        <span *ngIf="cardAward.character?.icon_url" class="award__body__info__character">
          <span><img src="{{ cardAward.character.icon_url }}" alt="{{ cardAward.character.title }}"></span>
          <span *ngIf="!award.is_used_card">Привилегия активна</span>
          <span *ngIf="award.is_used_card">Привилегия неактивна</span>
        </span>

        <span *ngIf="award?.for_what && isStudent" class="award__body__info__for_what">
          {{ award?.for_what }}
        </span>
        <textarea *ngIf="!isStudent" matInput formControlName="for_what" placeholder="За что?"></textarea>

        <span class="award__body__info__date">
          <span *ngIf="isStudent">{{ award.date | date }}</span>
          <input *ngIf="!isStudent" type="date" formControlName="date">
        </span>

        <br><br>

        <div class="award__body__info__comment">
          <span class="award__body__info__comment__text">
            <span *ngIf="isStudent">{{ award?.comment }}</span>
            <span *ngIf="!isStudent">
              <textarea cols="50" rows="8" matInput formControlName="comment" placeholder="Комментарий...">{{ award?.comment }}</textarea>
            </span>
          </span>

          <span *ngIf="award?.urls.length && isStudent" class="award__body__info__comment__links">
            <ul class="award__body__info__links">
              <li>Фото / видео</li>
              <li *ngFor="let link of award.urls">
                <a href="{{ link.link }}" target="_blank"><span class="material-icons">link</span></a>
              </li>
            </ul>
          </span>

          <ul *ngIf="!isStudent" class="settings_links">
            <li *ngFor="let link of filesLinks" class="settings_links__item">
              <a href="{{ link }}" target="_blank" (click)="showLink(link)"><span class="material-icons">link</span></a>
            </li>
            <button mat-button class="settings_links__button" (click)="addLink()" type="button">
              <span class="material-icons">link</span>
              <span>Добавить ссылку</span>
            </button>
          </ul>
          <mat-form-field *ngIf="!isStudent" class="link-form-field">
            <mat-label>Ссылка на файлы</mat-label>
            <input type="url" matInput formControlName="url" (keyup.enter)="addLink()"/>
            <mat-icon matSuffix (click)="deleteLink()">close</mat-icon>
          </mat-form-field>
        </div>
        <div *ngIf="!isStudent" class="award__confirms">
          <button mat-raised-button class="award__confirms__true" type="submit">Сохранить</button>
          <button mat-raised-button class="award__confirms__delete" (click)="openDialog(confirmDeleteAward)" type="button">Удалить</button>
        </div>
      </form>
    </div>
    <div *ngIf="award?.urls.length" class="award__footer">
      <ul class="award__footer__links">
        <li *ngFor="let link of award.urls">
          <a href="{{ link.link }}" target="_blank">
            <div *ngIf="link.image && link.file_type === 'Фото'" class="image__wrapper">
              <img src="{{ link.image }}" alt="ссылка" />
            </div>
            <div *ngIf="link.image && link.file_type !== 'Фото'" class="image__wrapper">
              <iframe [src]="getVideoUrl(link.image)" width="100%" height="auto"></iframe>
            </div>
          </a>
        </li>
      </ul>
    </div>
  </div>
</ng-container>


<ng-container *ngIf="purchase">
  <div class="award purchase">
    <div class="award__nav">
      <a class="award__nav__back" (click)="back()">
        <span><mat-icon class="award__nav__close">arrow_back</mat-icon></span>
        <span>Другие покупки</span>
      </a>
    </div>
    <div class="award__body" [class.not-active]="purchase.count_card_used >= purchase.count">
      <div class="award__body__preview">
        <div class="award__body__preview__active">
          <img src="{{ activatedImage }}" alt="{{ purchase.product.title }}">
        </div>
        <div *ngIf="purchase.product.images.length > 1" class="award__body__preview__images">
          <span *ngFor="let image of purchase.product.images"
                class="award__body__preview__images__item"
                [class.active]="image.url == activatedImage"
                (click)="activatedImage = image.url">
            <img src="{{ image.url }}" alt="{{ purchase.product.title }}">
          </span>
        </div>
      </div>
      <div class="award__body__info">
        <div class="purchase__body__info__count">
          <span>{{ purchase.summary_product_count }} шт.</span>
        </div>
        <div class="award__body__info__title">
          {{ purchase.product.title }}
        </div>
        <div class="purchase__body__info__price">
          <span class="purchase__body__info__price__count">{{ purchase.medium_price }} {{ currencyStr }}</span>
          <div *ngIf="purchase.product.character?.icon_url"  class="award__body__info__character">
            <span><img src="{{ purchase.product.character.icon_url }}" alt="{{ purchase.product.character.title }}"></span>
            <span *ngIf="purchase.count_card_used < purchase.count">Привилегия активна</span>
            <span *ngIf="purchase.count_card_used >= purchase.count">Привилегия неактивна</span>
          </div>
        </div>
        <div class="purchase__body__info__description">
          <span>{{ purchase.product.description }}</span>
        </div>
      </div>
    </div>
  </div>
</ng-container>
